import { createLogger } from 'redux-logger';
import { createReduxStore, createRtcMiddleware } from '@lifesize/nucleus';
import { remotingMiddlewares } from '@lifesize/clients.remoting';
import { Store } from 'redux';
import RootState from './constants/RootState';
import presentationMiddleware from './middleware/presentation';
import reducers, { globalInitialState } from './reducers';
import getApiDomain from 'utils/getApiDomain';
import update from 'middleware/update';
import Filters from './constants/Filters';
import { Logger } from '@lifesize/web-clients-core';
import { generateUID } from 'utils/generateUid';
import actions from 'actions/app';

const initialState = {
  app: globalInitialState,
  nucleus: {
    cluster: {
      url: getApiDomain()
    },
    localization: {
      localeCode: 'en'
    }
  }
};

export default async function createStore(): Promise<Store<RootState>> {
  const autobahn = require('autobahn');
  const url = new URL(window.location.href);
  const middlewares = [
    presentationMiddleware,
    update,
    remotingMiddlewares.pairing,
    remotingMiddlewares.remoting,
    remotingMiddlewares.wirelessPresentation
  ];

  Logger.listenForKeyboardShortcut();
  let loggerSessionUrl;
  if (Logger.isEnabled()) {
    loggerSessionUrl = await Logger.initialize('yw0xj3/dash-presenter', process.env.REACT_APP_VERSION || '0.0.1');
    middlewares.push(Logger.getMiddleware(Filters.stateLog, Filters.actionLog));
  }
  else if (window.lifesize.env === 'development' || url.searchParams.get('dev') === 'true' || localStorage.getItem('dev') === 'true') {
    const logger = createLogger({
      collapsed: true,
      duration: true,
      timestamp: true,
      diff: url.searchParams.get('reduxLoggerDiff') === 'true' || localStorage.getItem('reduxLoggerDiff') === 'true',
      predicate: (getState, action) => !Filters.actionLog.includes(action.type)
    });
    middlewares.push(logger);
  }

  const store = createReduxStore(reducers, middlewares, initialState, null, autobahn, createRtcMiddleware()) as Store<RootState>;
  if (loggerSessionUrl) {
    const existingId = localStorage.getItem('dashPresenterSupportId'); // If a user ever sees it, making it clear that the ID is for support is a good idea
    const userId = existingId ? existingId : generateUID();
    Logger.identify(userId, { role: 'PRESENTER' });
    localStorage.setItem('dashPresenterSupportId', userId);
    store.dispatch(actions.setLoggingId(userId));
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/createStore.ts